__turbopack_context__.v({
  "arrow": "CookieAccordion-module-scss-module__K5GO6G__arrow",
  "arrowExpanded": "CookieAccordion-module-scss-module__K5GO6G__arrowExpanded",
  "arrowWrapper": "CookieAccordion-module-scss-module__K5GO6G__arrowWrapper",
  "container": "CookieAccordion-module-scss-module__K5GO6G__container",
  "root": "CookieAccordion-module-scss-module__K5GO6G__root",
});
